<script>
import { prop, propEq } from 'rambda'
import ModalSimilarLaptops from './ModalSimilarLaptops'
import replaceLaptop from './replaceLaptop'

export default {
  components: {
    ModalSimilarLaptops,
  },
  data() {
    return {
      laptopForReplacementSelectedId: null,
    }
  },
  computed: {
    laptopBucketsNotSelectedLaptops() {
      return this.criteria.buckets
        .map(({ price }) => this
          .laptopEvaluationsSorted
          .filter(propEq('bucketPrice', price))
          .filter(prop('price'))
          .filter(prop('imageFileId'))
          .filter(({ id }) => !this.laptopIdsSelected.includes(id)))
    },
  },
  methods: {
    openLaptopsSimilarModal(laptopId) {
      this.laptopForReplacementSelectedId = laptopId
    },
    replaceLaptop(bucketIndex, selectedLaptopId, newLaptopId) {
      const laptopOld = this.articleLaptops
        .find(({ laptopId }) => laptopId === selectedLaptopId)
      const laptopNew = this.laptopBucketsNotSelectedLaptops[bucketIndex]
        .find(({ id }) => id === newLaptopId)

      const articleLaptopsReplaced = replaceLaptop(
        this.articleLaptops,
        this.laptopEvaluations,
        laptopOld,
        laptopNew,
        this.article.topic,
      )

      this.laptopForReplacementSelectedId = null
      this.setArticleLaptops(articleLaptopsReplaced)
    },
  },
  render: () => '',
}
</script>
